import { render, staticRenderFns } from "./WhiteLabel.vue?vue&type=template&id=0d6a4d1f&"
import script from "./WhiteLabel.vue?vue&type=script&lang=js&"
export * from "./WhiteLabel.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLabel.vue?vue&type=style&index=0&id=0d6a4d1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports